import { NIAT_NAT_TOPIN_LAUNCH_ROUTE_PATH } from '../RouteConstants';

export const natTopinLaunchRouteSeoInfo = {
  title: 'Take the NAT Exam | NIAT',
  description: 'Access your NAT exam and continue your assessment for the NIAT Upskilling.',
  path: NIAT_NAT_TOPIN_LAUNCH_ROUTE_PATH
};
